/* eslint-disable */
/*
 * Back-in-Stock Benachrichtigung (Klaviyo Client-Side Subscribe pro Variante).
 * Bottom-Sheet-Modal, slidet mobil von unten rein.
 * Trigger: jedes Element mit [data-bis-trigger] (Größen-Dropdown + Notify-Button).
 */
if (!customElements.get('back-in-stock-modal')) {
  customElements.define(
    'back-in-stock-modal',
    class BackInStockModal extends HTMLElement {
      constructor() {
        super();
        this.onKeydown = this.onKeydown.bind(this);
        this.onSubmit = this.onSubmit.bind(this);
        this.lastFocused = null;
        this.variantId = null;
      }

      connectedCallback() {
        // Guard gegen Re-Entry: das Portieren nach <body> (appendChild) löst disconnect+connect erneut aus.
        if (this.__bisInit) return;
        this.__bisInit = true;

        this.companyId = this.getAttribute('data-company-id');
        this.productId = this.getAttribute('data-product-id');
        this.currency = this.getAttribute('data-currency') || 'EUR';
        this.txtInvalid = this.getAttribute('data-text-invalid') || 'Bitte gib eine gültige E-Mail-Adresse ein.';
        this.txtConsent = this.getAttribute('data-text-consent') || 'Bitte bestätige die Datenschutzerklärung.';
        this.txtError = this.getAttribute('data-text-error') || 'Das hat leider nicht geklappt. Bitte versuche es noch einmal.';

        this.sheet = this.querySelector('.bis-modal__sheet');
        this.overlay = this.querySelector('[data-bis-overlay]');
        this.closeBtn = this.querySelector('[data-bis-close]');
        this.form = this.querySelector('[data-bis-form]');
        this.emailInput = this.querySelector('[data-bis-email]');
        this.consentInput = this.querySelector('[data-bis-consent]');
        this.feedback = this.querySelector('[data-bis-feedback]');
        this.submitBtn = this.querySelector('[data-bis-submit]');
        this.successBox = this.querySelector('[data-bis-success]');
        this.variantLabel = this.querySelector('[data-bis-variant-label]');

        this.overlay && this.overlay.addEventListener('click', () => this.close());
        this.closeBtn && this.closeBtn.addEventListener('click', () => this.close());
        this.form && this.form.addEventListener('submit', this.onSubmit);

        this.bindVariantChange();

        // Modal nach <body> portieren, damit es alle Stacking-Contexts der Vorfahren
        // (sticky Produkt-Form, transformierte Slider, Breadcrumbs) überlagert.
        if (this.parentElement && this.parentElement !== document.body) {
          document.body.appendChild(this);
        }

        // Klicks, die der Inline-Bootstrap abgefangen hat, bevor dieses Script geladen war, nachholen.
        var pending = window.__bisPending;
        if (pending && (pending.modal === this || !pending.modal)) {
          window.__bisPending = null;
          this.open.apply(this, pending.args);
        }
      }

      /* Modal schließen + zurücksetzen, wenn die Variante im Hintergrund wechselt. */
      bindVariantChange() {
        if (window.eventBus && typeof window.eventBus.on === 'function') {
          window.eventBus.on('variant:change', () => {
            if (this.classList.contains('bis-modal--open')) this.close();
          });
        }
      }

      open(variantId, variantTitle, productTitle, productImage) {
        if (!variantId) return;
        this.variantId = variantId;
        this.lastFocused = document.activeElement;
        this.resetForm();

        if (this.variantLabel) {
          if (variantTitle && variantTitle !== 'Default Title') {
            this.variantLabel.textContent = variantTitle;
            this.variantLabel.hidden = false;
          } else {
            this.variantLabel.hidden = true;
          }
        }

        // Produkttitel/-bild dynamisch setzen (wichtig bei Combined Listings / Farbgruppen)
        var titleEl = this.querySelector('[data-bis-product-title]');
        if (titleEl && productTitle) titleEl.textContent = productTitle;
        var thumbEl = this.querySelector('[data-bis-thumb]');
        if (thumbEl) {
          if (productImage) {
            thumbEl.src = productImage;
            thumbEl.hidden = false;
          } else if (!thumbEl.getAttribute('src')) {
            thumbEl.hidden = true;
          }
        }

        this.hidden = false;
        // Erst sichtbar machen, dann im nächsten Frame die Open-Klasse für die Slide-Animation setzen.
        requestAnimationFrame(() => {
          this.classList.add('bis-modal--open');
        });
        document.documentElement.classList.add('bis-modal-lock');
        document.addEventListener('keydown', this.onKeydown);
        setTimeout(() => this.emailInput && this.emailInput.focus(), 80);
      }

      close() {
        this.classList.remove('bis-modal--open');
        document.documentElement.classList.remove('bis-modal-lock');
        document.removeEventListener('keydown', this.onKeydown);
        const finish = () => {
          this.hidden = true;
          this.sheet && this.sheet.removeEventListener('transitionend', finish);
        };
        if (this.sheet) {
          this.sheet.addEventListener('transitionend', finish);
          setTimeout(finish, 600); // Fallback falls transitionend nicht feuert
        } else {
          finish();
        }
        if (this.lastFocused && typeof this.lastFocused.focus === 'function' && document.contains(this.lastFocused)) {
          this.lastFocused.focus();
        }
      }

      resetForm() {
        if (this.form) this.form.hidden = false;
        if (this.successBox) this.successBox.hidden = true;
        if (this.feedback) {
          this.feedback.hidden = true;
          this.feedback.textContent = '';
        }
        if (this.emailInput) this.emailInput.value = this.getAttribute('data-customer-email') || '';
        if (this.consentInput) this.consentInput.checked = false;
        if (this.submitBtn) this.submitBtn.disabled = false;
      }

      showFeedback(message) {
        if (!this.feedback) return;
        this.feedback.textContent = message;
        this.feedback.hidden = false;
      }

      onKeydown(e) {
        if (e.key === 'Escape') {
          this.close();
          return;
        }
        if (e.key !== 'Tab' || !this.sheet) return;
        // Focus-Trap innerhalb des Sheets, nur sichtbare Elemente (Form wird bei Erfolg ausgeblendet)
        const focusable = Array.prototype.filter.call(
          this.sheet.querySelectorAll(
            'button:not([disabled]), [href], input:not([disabled]), [tabindex]:not([tabindex="-1"])'
          ),
          (el) => el.offsetWidth > 0 || el.offsetHeight > 0 || el === document.activeElement
        );
        if (!focusable.length) return;
        const first = focusable[0];
        const last = focusable[focusable.length - 1];
        if (e.shiftKey && document.activeElement === first) {
          e.preventDefault();
          last.focus();
        } else if (!e.shiftKey && document.activeElement === last) {
          e.preventDefault();
          first.focus();
        }
      }

      onSubmit(e) {
        e.preventDefault();
        const email = (this.emailInput && this.emailInput.value || '').trim();
        if (!email || !/^[^@\s]+@[^@\s]+\.[^@\s]+$/.test(email)) {
          this.showFeedback(this.txtInvalid);
          this.emailInput && this.emailInput.focus();
          return;
        }
        if (this.consentInput && !this.consentInput.checked) {
          this.showFeedback(this.txtConsent);
          return;
        }
        if (this.feedback) this.feedback.hidden = true;
        this.subscribe(email);
      }

      subscribe(email) {
        if (!this.companyId || !this.variantId) {
          this.showFeedback(this.txtError);
          return;
        }
        this.submitBtn && (this.submitBtn.disabled = true);

        const payload = {
          data: {
            type: 'back-in-stock-subscription',
            attributes: {
              channels: ['EMAIL'],
              profile: { data: { type: 'profile', attributes: { email: email } } }
            },
            relationships: {
              variant: {
                data: { type: 'catalog-variant', id: '$shopify:::$default:::' + this.variantId }
              }
            }
          }
        };

        fetch('https://a.klaviyo.com/client/back-in-stock-subscriptions/?company_id=' + encodeURIComponent(this.companyId), {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            accept: 'application/json',
            revision: '2024-02-15'
          },
          body: JSON.stringify(payload)
        })
          .then((res) => {
            if (res.ok) {
              this.onSuccess();
            } else {
              this.submitBtn && (this.submitBtn.disabled = false);
              this.showFeedback(this.txtError);
            }
          })
          .catch(() => {
            this.submitBtn && (this.submitBtn.disabled = false);
            this.showFeedback(this.txtError);
          });
      }

      onSuccess() {
        if (this.form) this.form.hidden = true;

        // Conversion-Signal an dataLayer (GTM/Stape verarbeiten es consent-konform weiter).
        // Kein Klartext der E-Mail im dataLayer.
        try {
          var titleEl = this.querySelector('[data-bis-product-title]');
          var eid = (window.crypto && crypto.randomUUID) ? crypto.randomUUID() : ('bis-' + Date.now() + '-' + Math.random().toString(36).slice(2));
          window.dataLayer = window.dataLayer || [];
          window.dataLayer.push({
            event: 'back_in_stock_signup',
            event_id: eid,
            variant_id: this.variantId,
            product_id: this.productId || '',
            product_title: titleEl ? titleEl.textContent.trim() : '',
            variant_title: this.variantLabel ? this.variantLabel.textContent.trim() : '',
            content_ids: [String(this.variantId)],
            content_type: 'product',
            value: 0,
            currency: this.currency
          });
        } catch (e) {}

        if (this.successBox) {
          this.successBox.hidden = false;
          this.successBox.setAttribute('tabindex', '-1');
          this.successBox.focus();
        }
      }

      disconnectedCallback() {
        document.removeEventListener('keydown', this.onKeydown);
        document.documentElement.classList.remove('bis-modal-lock');
      }
    }
  );

  // Im Theme-Registry markieren, damit SafeLoadScripts das Script nicht mehrfach injiziert.
  if (window.wetheme && window.wetheme.webcomponentRegistry) {
    window.wetheme.webcomponentRegistry.register({ key: 'back-in-stock' });
  }
}
